'use strict';

angular.module('internal.investigations')
    .controller('InternalInvestigationDocuments', ['$scope', '$rootScope', 'DocumentTypes', 'Documents', function ($scope, $rootScope, DocumentTypes, Documents) {
        $scope.resetInvestigation();
        $scope.loading = true;
        $scope.bulkActionItems = [];
        $scope.bulkActionRunning = false;

        $scope.downloadZip = function (bulkApply) {
            if ($scope.bulkActionItems && $scope.bulkActionItems.length > 0) {
                $scope.bulkActionRunning = true;
                bulkApply.isOpen = false;

                Documents.downloadZip($scope.bulkActionItems).then(function (content) {
                    if (content) {
                        var link = document.createElement("a");
                        document.body.appendChild(link);
                        link.setAttribute("type", "hidden");
                        link.href = "data:text/plain;base64," + content;
                        link.download = "download.zip";
                        link.click();
                        document.body.removeChild(link);
                    }
                    $scope.bulkActionRunning = false;
                    
                });
            }
        };

        DocumentTypes.get({ check_permission: true }).then(function (types) {
            $scope.types = types;

            $scope.columns = [
                {
                    label: 'Name',
                    field: 'name',
                    hideActionPermission: {
                        types: $scope.types,
                        field: 'document_type_id'
                    },
                    link: {
                        state: 'internal.licensing.investigation.document',
                        params: [
                            {
                                name: 'investigationDocumentID',
                                field: 'id'
                            },
                            {
                                name: 'investigation_document',
                                field: ''
                            }
                        ]
                    }
                },
                {
                    label: 'Type',
                    field: 'document_type.name'
                },
                {
                    label: 'File',
                    field: 'file_name',
                    type: 'file',
                    permission: {
                        types: $scope.types,
                        field: 'document_type_id'
                    },
                    document: {
                        id: 'id',
                        code: 'code',
                        url: $rootScope.internalURL + 'controller.cfm?method=publicPortalService.openDocument'
                    }
                },
                {
                    label: 'Expiration Date',
                    field: 'expiration_date',
                    type: 'date'
                },
                {
                    label: 'Size',
                    field: 'file_size',
                    type: 'file_size'
                },
                {
                    label: 'Created On',
                    field: 'createdon',
                    type: 'date'
                },
                {
                    label: 'Created By',
                    field: 'createdby'
                }
            ];

            $scope.loading = false;
        })        

        $scope.filters = [
            {
                name: 'Document Type',
                field: 'document_type_id',
                service: 'DocumentTypes'
            }
        ];
    }])
;